import React, { useEffect, useState } from 'react'
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import AddJob from '../Authenticated/Employer/AddJob/AddJob'
import { EmployerJob, LoadingEmployerJob } from '../Authenticated/Employer/Job/EmployerJob'
import JobsManager from '../Authenticated/Employer/JobsManager/JobsManager'
import { EmployerPage } from '../Authenticated/Employer/Page/EmployerPage'
import { Prices } from '../Authenticated/Employer/Prices/Prices'
import EmployerHome from '../Authenticated/Employer/Home/EmployerHome'
import EmployerApplication from '../Authenticated/Employer/EmployerApplication/EmployerApplication'
import { authAxios } from '../API/apiRequest'
import { EmployerLayout } from '../Authenticated/Employer/Layout/EmployerLayout'
import { NotActive } from '../Authenticated/Employer/Components/HomePackage/HomePackage'
import EmailActivation from '../Authenticated/Employer/EmailActivation/EmailActivation'
import Report from '../Authenticated/Employer/Report/Report'
import Settings from '../Authenticated/Employer/Setting/Settings'
import CompanyInfo from '../Authenticated/Employer/CompanyInfo/CompanyInfo'
import ChangePassword from '../Authenticated/Employer/ChangePassword/ChangePassword'
import {NotFound} from "../components/NotFound/NotFound";
import Logout from '../Authenticated/Logout'

const AuthenticatedEmployer: React.FC = ()=>{

    const [loading, setLoading] = useState<boolean>(true)
    const [isActive, setIsActive] = useState<boolean | null>(null)
    const [emailStatus, setEmailStatus] = useState<string>('')
    useEffect(()=>{
      async function check(){
        try{
          let result = await authAxios.get('/employer/check')
          setIsActive(result.data.isActive)
          setEmailStatus(result.data.emailStatus)
          setLoading(false)
        }catch(e){
        }
      }
      check()
    }, [])


    if(loading) return <LoadingEmployerJob />
    if(!isActive || emailStatus === 'NOTACTIVE') return (
      <React.Fragment>
        <Switch>
        <Route path='/logout' exact component={Logout}/>
        <Route path='/mail/:type/:id' exact component={EmailActivation}/>
        <Route path='/PleaseWait' exact render={(props)=><PleaseWait {...props} emailStatus={emailStatus} />} />
          <Redirect from='*' to='/PleaseWait' />
        </Switch>
      </React.Fragment>
    )
    else
    return(
      <React.Fragment>
        <Switch>
        <Redirect exact from='/' to='/employer/home'/>
        <Redirect exact from='/PleaseWait' to='/employer/home'/>
        <Redirect exact from='/login' to='/employer/home'/>
        <Redirect exact from='/employer/step' to='/employer/home'/>
        <Route path='/employer/home' exact component={EmployerHome} /> 
        <Route path='/mail/:type/:id' exact component={EmailActivation}/>
        <Route path='/employer/job/:id' exact component={EmployerJob}/>
        <Route path='/employer/application/:id' exact component={EmployerApplication}/>
        <Route path='/employer/price' exact component={Prices}/>
        <Route path='/employer/page' exact component={EmployerPage}/>
        <Route path='/employer/addjob' exact component={AddJob}/>
        <Route path='/employer/editjob/:id' exact component={AddJob}/>
        <Route path='/employer/jobs' exact component={JobsManager}/>
        <Route path='/employer/report' exact component={Report}/>
        <Route path='/employer/settings' exact component={Settings}/>
        <Route path='/employer/settings/change-password' exact component={ChangePassword}/>
        <Route path='/employer/settings/info' exact component={CompanyInfo}/>
        <Route path='/logout' exact component={Logout}/>
        <Route path='/404' exact component={NotFound} />
           <Redirect from='*' to='/404' />
        </Switch>
      </React.Fragment>
    )
}



const PleaseWait: React.FC<RouteComponentProps & {emailStatus: string}> = (props)=>{

  return(
    <EmployerLayout>
      {props.emailStatus === 'NOTACTIVE' && (
        <div style={{backgroundColor: '#343a40', padding: 15, marginTop: 15, marginBottom: 15}}>
          <p style={{textAlign: 'center', color: '#fff'}}>يرجي تأكيد البريد الإلكتروني </p>
          <p style={{textAlign: 'center', color: '#fff'}}>لقد تم إرسال رسالة التأكيد إلي البريد </p>
      </div>)}
      <NotActive />
    </EmployerLayout>
  )
} 


export default AuthenticatedEmployer